import React from 'react';

const FEEDBACK_EMAIL = 'vaibhav@designersprescription.com';

const Notification = () => {
    return (
        <div id="dropdown-cta" className="w-full min-w-0 max-w-full p-4 mt-6 rounded-lg bg-red-50 overflow-hidden" role="alert">
            <div className="flex items-center mb-3">
                <span className="bg-red-100 text-red-800 text-sm font-semibold me-2 px-2.5 py-0.5 rounded">Announcement!</span>
            </div>
            <p className="mb-2 text-sm text-red-800">
               If you have any feedback, please send it to us here or contact us at
            </p>
            <a
              href={`mailto:${FEEDBACK_EMAIL}`}
              className="block mb-3 text-[11px] leading-tight text-red-800 underline whitespace-nowrap hover:text-red-900"
            >
              {FEEDBACK_EMAIL}
            </a>
            <a className="text-sm text-gray-600 underline font-medium hover:text-red-900" href={`mailto:${FEEDBACK_EMAIL}`}>Send Feedback here</a>
        </div>
    );
};

export default Notification;
